import { faGithub, faLinkedin, faStackOverflow, faCodepen} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Sidebar() {
    return <div className="fixed hidden xl:grid grid-cols-4 gap-2 bottom-0 left-0 w-48 px-4 py-4 text-2xl">
        <a className="origin-center transition hover:scale-110 hover:text-four" href="https://github.com/Ruin9999" target="_blank" rel="noreferrer">
            <FontAwesomeIcon className="m-auto" icon={faGithub} size="lg"/>
        </a>
        <a className="origin-center transition hover:scale-110 hover:text-four" href="https://www.linkedin.com/in/shun-jie-yong-9009bb164/" target="_blank" rel="noreferrer">
            <FontAwesomeIcon className="m-auto" icon={faLinkedin} size="lg"/>
        </a>
        <a className="origin-center transition hover:scale-110 hover:text-four" href="https://stackoverflow.com/users/10112479/ruin9999" target="_blank" rel="noreferrer">
            <FontAwesomeIcon className="m-auto" icon={faStackOverflow} size="lg"/>
        </a>
        <a className="origin-center transition hover:scale-110 hover:text-four" href="https://codepen.io/ruin9999" target="_blank" rel="noreferrer">
            <FontAwesomeIcon className="m-auto" icon={faCodepen} size="lg"/>
        </a>
    </div>
}

export default Sidebar;